import {KeasyBootstrap} from './keasy-bootstrap';

declare let window: KeasyBootstrap;

window.fadeOutLogin = (): void => {
    const login = document.querySelector('.login');

    if (!login) {
        return;
    }

    login.classList.replace('login--move-in', 'login--move-out');
}